<template>
    <div class="here-map">
        <div ref="map" v-bind:style="{ width: width, height: height }"></div>
    </div>
</template>

<script>
    export default {
        name: "heremap",
        data() {
            return {
                appCode: "YQkYE1CnGBM8HOPmhYLeuVuOmdeNghzsS--u_wVIsIE",
                appId: "XJrgma7seQbZ2brytcwk",
                map: {},
                searchService: {},
                ui: null,
                platform: null
            }
        },
        props: {
            lat: Number,
            lng: Number,
            width: String,
            height: String,
            interactive: {
                type: Boolean,
                default: () => (false)
            },
            showPositionMarker: {
                type: Boolean,
                default: () => (true)
            },
            picker: {
                type: Boolean,
                default: () => (false)
            }
        },
        created() {
            const H = window.H;
            // Initialize the platform object and geocoding service
            this.platform = new H.service.Platform({
                "app_id": this.appId,
                "apiKey": this.appCode,
                "useHTTPS": true
            });
            this.searchService = this.platform.getSearchService();
        },
        mounted() {
            const H = window.H;
            
            // Obtain the default map types from the platform object
            var maptypes = this.platform.createDefaultLayers();

            // Instantiate (and display) a map object:
            this.map = new H.Map(this.$refs.map, maptypes.vector.normal.map, {
                zoom: 16,
                center: {lat: this.lat, lng: this.lng}
            });

            addEventListener("resize", () => this.map.getViewPort().resize());

            if(this.showPositionMarker){
                this.dropMarker({lat: this.lat, lng: this.lng});
            }


            if(this.interactive){
                // add behavior control
                new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));
                
                if(this.picker){
                    let self = this;
                    this.map.addEventListener('tap', function(evt) {
                        var point = self.map.screenToGeo(evt.currentPointer.viewportX, evt.currentPointer.viewportY);
                        self.dropMarker(point);
                        self.reverseGeocode(point);
                        self.$emit("locationSelected", point);
                    });
                }

                this.ui = H.ui.UI.createDefault(this.map, maptypes, 'de-DE');
            }

            // add UI
            //H.ui.UI.createDefault(this.map, maptypes);
        },
        methods: {
            dropMarker(position, clearMap=true){
                const H = window.H
                if(clearMap){
                    this.clearMap();
                }
                let marker = new H.map.Marker({lat: position.lat, lng: position.lng});
                this.map.addObject(marker);
            },
            showInfoBubble(position, text){
                if(this.ui != null){
                    this.ui.addBubble(new H.ui.InfoBubble(position, {
                        content: text
                    }));
                }
            },
            clearMap(removeMarkers = true, removeInfoBubbles = true){
                // remove markers
                this.map.removeObjects(this.map.getObjects());

                if(this.ui != null){
                    // remove info bubbles
                    this.ui.getBubbles().forEach((bubble) => {
                        this.ui.removeBubble(bubble);
                    });  
                }
            },
            geocode(query){
                let self = this;
                this.searchService.geocode({q: query}, data => {
                    self.$emit("searchResultsUpdated", data.items);
                }, error => {
                    console.error(error);
                })
            },
            reverseGeocode(position){
                let self = this;
                this.searchService.reverseGeocode({
                        at: position.lat + ',' + position.lng + ",150"
                    }, (result) => {
                        if(result.items.length > 0){
                            // use the best match
                            let item = result.items[0];
                            self.$emit("markerReverseGeocoded", item.address.label)
                        }
                    }, error => {
                        console.error(error);
                });
            },
            setCenter(position, infoText, addMarker = false){
                this.clearMap();
                this.map.setCenter(position, true);
                if(addMarker){
                    this.dropMarker(position, false);
                }
                if(infoText != null){
                    this.showInfoBubble(position, infoText);
                }
            }
        }

    }
</script>

<style scoped></style>